import { render, staticRenderFns } from "./text-length.vue?vue&type=template&id=5e795c2a&scoped=true&"
import script from "./text-length.vue?vue&type=script&lang=js&"
export * from "./text-length.vue?vue&type=script&lang=js&"
import style0 from "./text-length.vue?vue&type=style&index=0&id=5e795c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e795c2a",
  null
  
)

export default component.exports